var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "product-review-head" }, [
    _vm.answer
      ? _c(
          "div",
          { staticClass: "product-review-head__avatar answer" },
          [
            _c("f-sprite-icon", {
              attrs: { "icon-link": _vm.$options.icons.avatarAnswer.id }
            })
          ],
          1
        )
      : _c(
          "div",
          { staticClass: "product-review-head__avatar" },
          [
            _c("f-sprite-icon", {
              attrs: { "icon-link": _vm.$options.icons.avatarBg.id }
            })
          ],
          1
        ),
    _c(
      "div",
      { staticClass: "product-review-head__info-wrap" },
      [
        _c("div", [
          _c("span", { staticClass: "product-review-head__name" }, [
            _vm._v("\n        " + _vm._s(_vm.userName) + "\n      ")
          ]),
          _c("span", { staticClass: "product-review-head__info" }, [
            _vm._v("\n        " + _vm._s(_vm.date) + "\n      ")
          ])
        ]),
        !_vm.answer
          ? [
              _c(
                "div",
                {
                  staticClass:
                    "product-review-head__info product-review-head__info-offset"
                },
                [_vm._v("\n        " + _vm._s(_vm.city) + "\n      ")]
              ),
              _c(
                "div",
                {
                  staticClass:
                    "product-review-head__info product-review-head__info-offset2"
                },
                [
                  _vm._v(
                    "\n        Срок использования: " +
                      _vm._s(_vm.useTime) +
                      "\n      "
                  )
                ]
              ),
              _c(
                "div",
                { staticClass: "product-review-head__rating-wrap" },
                [
                  _c("stars-rating", {
                    staticClass: "product-review-head__stars-rating",
                    attrs: { size: "12", value: _vm.rating }
                  }),
                  _vm.recommended
                    ? _c(
                        "div",
                        { staticClass: "product-review-head__recommends" },
                        [_vm._v("\n          Рекомендую!\n        ")]
                      )
                    : _vm._e()
                ],
                1
              )
            ]
          : _vm._e()
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }